<template>
   <div
      class="relative"
      :class="[
         'pl-12',
         position === 'left' ? 'md:mr-[50%] md:pr-16 md:pl-0' : 'md:ml-[50%] md:pl-16',
         'w-full md:w-[50%]'
      ]"
   >
      <Link
         :href="
            route('events.view', {
               event: event.slug
            })
         "
      >
         <div class="rounded-lg shadow-xl overflow-hidden group hover:opacity-75 relative">
            <div
               class="aspect-h-72 sm:aspect-h-80 aspect-w-1 w-full h-72 sm:h-80 overflow-hidden rounded-lg bg-gray-100 relative"
            >
               <img
                  loading="lazy"
                  :srcset="
                     event.thumbnail.original_url
                  "
                  :alt="event.title"
                  class="h-full object-center object-cover w-full absolute transform transition duration-500 group-hover:scale-105"
               >
               <div class="h-full w-full left-0 top-0 absolute bg-neutral-950 bg-opacity-60 rounded-lg" />
            </div>

            <!-- Bottom content -->
            <div class="absolute bottom-0 flex-col justify-start p-4">
               <div
                  v-if="
                     !isEmpty(
                        event.location_name
                     )
                  "
                  class="flex items-center gap-x-1"
               >
                  <svg
                     xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 24 24"
                     fill="white"
                     class="w-4 h-4"
                  >
                     <path
                        fill-rule="evenodd"
                        d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
                        clip-rule="evenodd"
                     />
                  </svg>
                  <div class="text-white text-base font-medium">
                     {{
                        event.location_name
                     }}
                  </div>
               </div>
               <div class="text-white text-xl font-extrabold uppercase">
                  {{ event.title }}
               </div>
               <span
                  v-if="
                     event.fully_booked &&
                        !event.in_past
                  "
                  class="inline-flex items-center rounded-md bg-red-100 px-2 py-1 text-xs font-medium text-red-700"
               >Event Fully Booked</span>
               <span
                  v-if="event.in_past"
                  class="inline-flex items-center rounded-md bg-yellow-100 px-2 py-1 text-xs font-medium text-yellow-800"
               >Ended</span>
            </div>

            <!-- Top right time -->
            <div
               v-if="event.start_time"
               class="top-0 right-0 absolute p-4"
            >
               <div class="flex items-center space-x-2">
                  <i class="pi pi-clock !text-white" />
                  <p class="text-center text-white text-base font-bold uppercase">
                     {{ event.start_time }}
                  </p>
               </div>
            </div>

            <!-- Top left date -->
            <div class="pt-4 top-0 left-0 absolute ml-2">
               <div class="flex items-center gap-x-1">
                  <p class="text-center text-white text-base font-bold">
                     {{
                        dayjs(
                           event.start_date,
                           'DD-MM-YYYY',
                        ).format(
                           'DD MMMM YYYY',
                        )
                     }}
                  </p>
               </div>
            </div>
         </div>
      </Link>


      <!-- Timeline circle and line connector -->
      <div class="absolute top-1/2 left-0 -translate-x-1/2 md:hidden">
         <div class="w-6 h-6 rounded-full bg-primary-color z-10 relative" />
      </div>

      <!-- Desktop timeline circle and connector -->
      <div
         class="absolute top-1/2 hidden md:block"
         :class="[position === 'left' ? 'right-0 translate-x-1/2' : 'left-0 -translate-x-1/2']"
      >
         <div class="w-6 h-6 rounded-full bg-primary-color  z-10 relative" />
      </div>
   </div>
</template>
<script setup>
   import { Link } from '@inertiajs/vue3';
   import dayjs from 'dayjs';

   defineProps({
      event: Object,
      position: String,
   });

   const isEmpty = (value) => {
      return value === undefined || value === null || value === '';
   };
</script>
